export interface ModuleDefinition {
  id: string;
  name: string;
  description: string;
  nodeTypes: string[];
  edgeTypes: string[];
  defaultEnabled: boolean;
  dependencies?: string[]; // Other modules required
}

export const MODULE_REGISTRY: Record<string, ModuleDefinition> = {
  'base-crm': {
    id: 'base-crm',
    name: 'Base CRM',
    description: 'Organizations, people, activities',
    nodeTypes: ['Person', 'Organization', 'Activity', 'Task', 'Document'],
    edgeTypes: ['WORKS_AT', 'HAS_ACTIVITY', 'HAS_TASK', 'HAS_DOCUMENT', 'REPORTS_TO', 'PARTICIPATED_IN', 'RELATED_TO'],
    defaultEnabled: true,
  },
  sales: {
    id: 'sales',
    name: 'Sales',
    description: 'Sales pipeline and opportunity tracking',
    nodeTypes: ['Opportunity'],
    edgeTypes: ['OPPORTUNITY_FOR', 'HAS_CONTACT'],
    defaultEnabled: false,
    dependencies: ['base-crm'],
  },
  marketing: {
    id: 'marketing',
    name: 'Marketing',
    description: 'Campaign management and event tracking',
    nodeTypes: ['Campaign', 'Event'],
    edgeTypes: ['IN_LIST', 'SENT_TO_LIST', 'ATTENDED'],
    defaultEnabled: false,
    dependencies: ['base-crm'],
  },
  'pevc-fundraising': {
    id: 'pevc-fundraising',
    name: 'PE/VC Fundraising',
    description: 'LP fundraising pipeline management',
    nodeTypes: ['Vehicle', 'FundraisingOpportunity'],
    edgeTypes: ['FUNDRAISING_FOR', 'INTERESTED_IN'],
    defaultEnabled: false,
    dependencies: ['base-crm'],
  },
  'pevc-ir': {
    id: 'pevc-ir',
    name: 'PE/VC Investor Relations',
    description: 'Subscriptions, capital calls, distributions, reports',
    nodeTypes: ['Subscription', 'InvestmentAccount', 'CapitalCall', 'Distribution', 'Report'],
    edgeTypes: ['COMMITTED_TO', 'APPLIES_TO', 'SENT_TO'],
    defaultEnabled: false,
    dependencies: ['base-crm', 'pevc-fundraising'],
  },
  'pevc-dealflow': {
    id: 'pevc-dealflow',
    name: 'PE/VC Deal Flow',
    description: 'Investment pipeline management',
    nodeTypes: ['Deal'],
    edgeTypes: ['DEAL_WITH', 'SOURCED_BY', 'ASSIGNED_TO', 'CONVERTED_TO'],
    defaultEnabled: false,
    dependencies: ['base-crm'],
  },
  'pevc-portfolio': {
    id: 'pevc-portfolio',
    name: 'PE/VC Portfolio',
    description: 'Portfolio company tracking and performance',
    nodeTypes: ['Investment', 'ExternalFund'],
    edgeTypes: ['INVESTED_IN', 'MANAGES'],
    defaultEnabled: false,
    dependencies: ['base-crm'],
  },
  pmn: {
    id: 'pmn',
    name: 'PMN',
    description: 'Properties, Metrics, and Narrative',
    nodeTypes: ['Property', 'Metric', 'Narrative'],
    edgeTypes: ['HAS_PROPERTY', 'HAS_METRIC', 'HAS_NARRATIVE'],
    defaultEnabled: true,
  },
};

export function getModule(moduleId: string): ModuleDefinition | undefined {
  return MODULE_REGISTRY[moduleId];
}

export function getAllModules(): ModuleDefinition[] {
  return Object.values(MODULE_REGISTRY);
}

export function getNodeTypeModule(nodeType: string): string | undefined {
  for (const [moduleId, module] of Object.entries(MODULE_REGISTRY)) {
    if (module.nodeTypes.includes(nodeType)) {
      return moduleId;
    }
  }
  return undefined;
}

export function getEdgeTypeModule(edgeType: string): string | undefined {
  for (const [moduleId, module] of Object.entries(MODULE_REGISTRY)) {
    if (module.edgeTypes.includes(edgeType)) {
      return moduleId;
    }
  }
  return undefined;
}
